import axios from 'axios';
import { User, LoginFormData, RegisterFormData, AuthResponse } from '../types';

// Configuration de l'instance Axios
const api = axios.create({
  baseURL: '/api/auth',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token à chaque requête
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Intercepteur pour gérer les erreurs de réponse
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expiré ou invalide
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authService = {
  // Connexion
  async login(data: LoginFormData): Promise<AuthResponse> {
    const response = await api.post('/login', data);
    return response.data;
  },

  // Inscription
  async register(data: RegisterFormData): Promise<AuthResponse> {
    const response = await api.post('/register', data);
    return response.data;
  },

  // Récupérer les informations de l'utilisateur connecté
  async getMe(token?: string): Promise<User> {
    const response = await api.get('/me', {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    return response.data.user;
  },

  // Renouveler le token
  async refreshToken(token: string): Promise<{ token: string }> {
    const response = await api.post('/refresh', {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },
};
